import React from "react";

import {
    Box, Breadcrumbs,
    Button,
    Card,
    CardActionArea,
    CardContent,
    CssBaseline,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid, Link,
    List,
    ListItem,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    ThemeProvider,
    Typography,
    useMediaQuery
} from "@mui/material";
import { lightTheme } from "./Themes";
import { Portada } from "./components/Portada";
import { TopBar } from "./components/TopBar";
import { NavigationMenu } from "./components/NavigationMenu";
import { BottomBanner } from "./components/BottomBanner";
import {
    Campaign,
    Description,
    Download,
    EmojiEvents,
    EventAvailable,
    FileDownload, House,
    Info,
    InsertDriveFile,
    Payment,
    PictureAsPdf,
    Settings
} from "@mui/icons-material";
import { FechasImportantes } from "./components/FechasImportantes";
import { useLocation, useNavigate } from "react-router-dom";
import { Skyline } from "./components/Skyline";
import call_for_papers from "./documents/CfP_URSI_2026.pdf"
import template_word_es from "./documents/Plantilla_espanol_Word_URSI_2026.docx"
import template_word_en from "./documents/English_Template_Word_URSI_2026.docx"
import template_latex_es from "./documents/LaTeXURSI2026_es.zip"
import template_latex_en from "./documents/LaTeXURSI2026_en.zip"
import PlaceIcon from '@mui/icons-material/Place';
import img0 from "./images/sede_guajara/guajara-000.jpg"
import img1 from "./images/sede_guajara/guajara-001.jpg"
import img2 from "./images/sede_guajara/guajara-002.jpg"
import img3 from "./images/sede_guajara/guajara-003.jpg"
import img4 from "./images/sede_guajara/guajara-004.jpg"
import img5 from "./images/sede_guajara/guajara-005.jpg"
import { convocatoriaSesionesUrl, globalMaxWidth } from "./GlobalConfigs";

function Simposio({ idx }) {
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="App">
                <CssBaseline />
                <Stack alignItems='center'>
                    <TopBar />
                    <NavigationMenu />
                    <Portada with_buttons={false} construction_text={false} />
                    <BreadcrumbSection />
                    <Menu idx={idx} />
                    <Skyline />
                    <BottomBanner />
                </Stack>
            </div>
        </ThemeProvider>
    )
}

function BreadcrumbSection() {
    return (
        <Breadcrumbs aria-label="breadcrumb" margin={2}>
            <Link underline="hover" color="inherit" href="/">
                Home
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Simposio</Typography>
        </Breadcrumbs>
    );
}


function Menu({ idx }) {
    const navigate = useNavigate();

    const contents = Array(
        // <Programas/>,
        <FechasImportantes />,
        <Areas />,
        <Comités />,
        <Sede />,
        <Comunicaciones />,
        <Inscripciones />,
        <Premios />
    );

    const icons = Array(
        // <FileDownload color='primary'/>,
        <EventAvailable color='primary' />,
        <Info color='primary' />,
        <House color='primary' />,
        <Settings color='primary' />,
        <Campaign color='primary' />,
        <Payment color='primary' />,
        <EmojiEvents color='primary' />
    );

    const cards = [
        // {
        //     title: 'Programas URSI 2026',
        //     href: 'programas'
        // },
        {
            title: 'Fechas Importantes',
            href: 'fechas'
        },
        {
            title: 'Áreas Temáticas',
            href: 'areas'
        },
        {
            title: 'Comités',
            href: 'comites'
        },
        {
            title: 'Sede',
            href: 'sede'
        },
        {
            title: 'Comunicaciones',
            href: 'comunicaciones'
        },
        {
            title: 'Inscripciones y Tarifas',
            href: 'inscripciones'
        },
        {
            title: 'Premios y Concursos',
            href: 'premios'
        }
    ];

    function Contents() {
        return (
            <Box component={Stack} direction="column" spacing={2} margin={4} sx={{}}>
                {
                    contents[idx]
                }
            </Box>
        );
    }

    function ButtonsMenu() {
        const compact_layout = useMediaQuery(lightTheme.breakpoints.down('lg'), {
            defaultMatches: true
        });

        if (!compact_layout)
            return (
                <Box component={Stack} direction="column" spacing={2} margin={4} sx={{}}>
                    {
                        cards.map((card, index) => (
                            <Card variant='outlined' key={'Card ' + index} id={'Card ' + index}>
                                <CardActionArea
                                    onClick={() => {
                                        navigate('/simposio/' + card.href);
                                    }}
                                    data-active={idx === index ? '' : undefined}
                                    sx={{
                                        height: '100%',
                                        '&[data-active]': {
                                            backgroundColor: 'action.selected',
                                            '&:hover': {
                                                backgroundColor: 'action.selectedHover',
                                            },
                                        },
                                    }}
                                >
                                    <CardContent>
                                        <Stack direction="row" alignItems='center' margin={0} spacing={2}>
                                            {icons[index]}
                                            <Typography variant="h6" align='left'>
                                                {card.title}
                                            </Typography>
                                        </Stack>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        ))
                    }
                </Box>
            );
        else {
            return (
                <Grid container spacing={0} justifyContent='space-around' sx={{
                    '--Grid-borderWidth': '1px',
                    borderTop: 'var(--Grid-borderWidth) solid',
                    borderBottom: 'var(--Grid-borderWidth) solid',
                    borderColor: 'divider',
                }}>
                    {
                        cards.map((card, index) => (
                            <Grid item>
                                <Button onClick={() => {
                                    navigate('/simposio/' + card.href);
                                }}
                                    data-active={idx === index ? '' : undefined}
                                    sx={{
                                        height: '100%',
                                        '&[data-active]': {
                                            backgroundColor: 'action.selected',
                                            '&:hover': {
                                                backgroundColor: 'action.selectedHover',
                                            },
                                        },
                                    }}
                                >
                                    {card.title}
                                </Button>
                            </Grid>
                        ))
                    }
                </Grid>
            );

        }
    }


    return (
        <Box component={Stack} direction={{ lg: "row", md: "column" }} margin={{ lg: 6, md: 0 }} sx={{
            boxShadow: { lg: 8, md: 0 },
            borderRadius: '7px'
        }}>
            <ButtonsMenu />
            <Divider variant='middle' orientation='vertical' flexItem />
            <Contents />
        </Box>
    );
}

function Programas() {
    return (
        <Stack direction="column" margin={6} alignItems='center' width={1} spacing={6}>
            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Programa Científico URSI 2026
                </Typography>
                <Divider />
                <Typography variant='body1'>
                    Todos los detalles de las jornadas del simposio URSI26-La Laguna,
                    así como la distribución de las contribuciones, ya están disponibles
                    en el <a href="">programa científico del congreso</a>:
                </Typography>
                <Stack alignItems='center'>
                    <Button variant='contained'>
                        <Stack alignItems='center'>
                            <Download color='white' />
                            <Typography>
                                Consultar Programa Científico
                            </Typography>
                        </Stack>
                    </Button>
                </Stack>
            </Stack>


            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Programa Social URSI 2026
                </Typography>
                <Divider />
                <Typography variant='body1'>
                    La Laguna nos ofrece un entorno único, y el <a href=''> programa social</a> está
                    pensado para que lo descubras a fondo. Descárgalo y revisa cada
                    una de las actividades que hemos organizado para ti:
                </Typography>
                <Stack alignItems='center'>
                    <Button variant='contained'>
                        <Stack alignItems='center'>
                            <Download color='white' />
                            <Typography>
                                Descargar Programa Social
                            </Typography>
                        </Stack>
                    </Button>
                </Stack>
            </Stack>


            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Libro de Actas y Contribuciones URSI 2026
                </Typography>
                <Divider />
                <Typography variant='body1'>
                    Accede al libro de actas del congreso y descarga también el archivo comprimido
                    (ZIP) que reúne todas las contribuciones presentadas en esta edición URSI 2026.
                </Typography>
                <Stack alignItems='center'>
                    <Button variant='contained'>
                        <Stack alignItems='center'>
                            <Download color='white' />
                            <Typography>
                                Descargar Libro de Actas
                            </Typography>
                        </Stack>
                    </Button>
                </Stack>
            </Stack>
        </Stack>
    )
}

function Areas() {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [selectedSession, setSelectedSession] = React.useState(null);

    const specialSessions = [
        { name: "Desarrollos para la radioastronomía y la geodesia en las Islas Canarias", summary: "Sesión especial sobre desarrollos en radioastronomía y geodesia en las Islas Canarias." },
        { name: "Tecnología TIC aplicada al Turismo", summary: "El turismo es uno de los sectores económicos más dinámicos y de mayor impacto social a nivel global, y su evolución está cada vez más ligada a la incorporación de tecnologías disruptivas en todos los niveles de la cadena de valor. La digitalización del sector turístico no solo transforma la experiencia de los visitantes, sino que también optimiza la gestión de destinos, mejora la sostenibilidad y abre nuevas oportunidades de negocio para operadores, instituciones y comunidades locales. En este contexto, el papel de las tecnologías de la información y las telecomunicaciones es central. La convergencia de Inteligencia Artificial (IA), Internet de las Cosas (IoT), comunicaciones móviles de última generación (5G y 6G), y nuevas arquitecturas de red permiten habilitar aplicaciones de gran valor añadido: desde la gestión inteligente de flujos turísticos hasta experiencias inmersivas basadas en realidad aumentada o metaverso. Al mismo tiempo, conceptos como Joint Communications and Sensing (JC&S), redes semánticas, edge computing y soluciones SoLoMo (Social, Local, Mobile) están contribuyendo a crear entornos turísticos hiperconectados, personalizados y más sostenibles. La presente sesión especial busca reunir trabajos de investigación y experiencias prácticas que aborden la interacción entre turismo y tecnología desde una perspectiva multidisciplinar. El objetivo es identificar tendencias, retos y oportunidades en el despliegue de estas tecnologías, así como contribuir al diseño de destinos turísticos inteligentes y resilientes. Temas de interés (no limitativos): Inteligencia Artificial aplicada a la personalización de la experiencia turística, Sistemas de recomendación basados en datos contextuales y de comportamiento, IoT para la monitorización de recursos turísticos, gestión de infraestructuras y sostenibilidad, Aplicaciones de 5G/6G en destinos turísticos inteligentes, Destinos turísticos inteligentes o cognitivos, Joint Communications and Sensing para servicios de localización y experiencia aumentada, Integración de SoLoMo (Social, Local, Mobile) en marketing turístico y gestión de destinos, Uso de edge computing y cloud computing en la provisión de servicios turísticos, Realidad aumentada, realidad virtual y metaverso en experiencias culturales y de ocio, Análisis de big data y redes semánticas para la gestión de flujos turísticos, Seguridad, privacidad y confianza en el uso de TIC en turismo, Modelos de turismo inteligente para entornos urbanos y rurales, Tecnologías para la accesibilidad y la inclusión en la experiencia turística, Casos de uso de turismo sostenible apoyados en TIC." },
        { name: "Metasuperficies para el control y radiación de campo", summary: "Esta sesión se adentra en el diseño y la aplicación avanzada de metasuperficies y estructuras periódicas para el control, generación, manipulación y emisión de ondas electromagnéticas, superando los límites de los dispositivos convencionales. La sesión se centrará en superficies con modulación espacial y temporal, con el fin de dar valor a funcionalidades estáticas y dinámicas demandadas en el ámbito de las comunicaciones actuales. Los temas abarcan desde el modelado numérico hasta la caracterización experimental, incluyendo aplicaciones prácticas, donde destacamos: Comunicaciones inalámbricas (haces conformados, RIS o Superficies Inteligentes Reconfigurables), Sistemas de imagen y sensado (funcionalidades de lentes planas, holografía, camuflaje), Antenas de alto rendimiento y alta frecuencia (haz directivo, multifunción y ultracompactas). Dispositivos con modulación espacial y/o temporal (conversión de frecuencia, no reciprocidad, amplificación). La sesión está especialmente interesada en contribuciones que exploren la síntesis y diseño de metasuperficies para radiación y control de onda, estructuras periódicas con modulación espacial y/o temporal, metasuperficies activas y reconfigurables, y su aplicación en sistemas dinámicos de comunicaciones y sensado. La sesión promueve el intercambio multidisciplinar entre investigadores que trabajan en el diseño, caracterización, modelado numérico y fabricación de estas superficies artificiales. Su relevancia se consolida por el creciente interés industrial y académico, la convergencia con tecnologías emergentes —como superficies inteligentes reconfigurables o el espacio-tiempo modulado— y el papel estratégico de estos desarrollos en la evolución de sistemas de comunicaciones, radar y control electromagnético avanzado." },
        { name: "Componentes pasivos para aplicaciones espaciales", summary: "La sesión especial Componentes Pasivos para Aplicaciones Espaciales abordará los avances más relevantes en el diseño, optimización y validación de dispositivos pasivos utilizados en cargas útiles satelitales y sistemas espaciales de alta fiabilidad. Se presentarán desarrollos en filtros, multiplexores, guías de onda, acopladores, resonadores y antenas pasivas, junto con nuevas técnicas de fabricación basadas en materiales avanzados, miniaturización y tecnologías aditivas, orientadas a reducir masa, volumen y costes sin comprometer el rendimiento. En el contexto del URSI 2026, esta sesión busca fomentar el intercambio entre comunidad científica, industria y agencias espaciales, promoviendo la colaboración ante retos como el funcionamiento en bandas emergentes, la exposición a entornos hostiles y la estandarización de ensayos. El objetivo es proporcionar una visión actualizada del estado del arte y de las tendencias que definirán la próxima generación de infraestructuras espaciales, destacando la importancia estratégica de los componentes pasivos en la evolución tecnológica del sector." },
        { name: "Sistemas radiantes reconfigurables adaptables al entorno para comunicación y detección", summary: "La sesión \"Sistemas radiantes reconfigurables adaptables al entorno para comunicación y detección\" se centrará en los avances en sistemas de radiación reconfigurables que se adaptan de manera inteligente al entorno para optimizar el rendimiento en comunicaciones y detección. Se explorarán técnicas de antenas inteligentes, arrays adaptativos y metamateriales reconfigurables capaces de ajustar patrones de radiación, frecuencia y polarización en tiempo real según las condiciones del canal y las necesidades de la aplicación. Se presentarán aplicaciones en comunicaciones inalámbricas avanzadas, redes 5G/6G, radar, sensores remotos y sistemas de monitoreo, así como los desafíos asociados a eficiencia, control dinámico, miniaturización y confiabilidad." },
        { name: "Antenas y dispositivos de RF basados en nuevas técnicas y tecnologías de fabricación", summary: "La sesión \"Antenas y dispositivos de RF basados en nuevas técnicas y tecnologías de fabricación\" abordará los avances recientes en el diseño y producción de antenas y dispositivos de radiofrecuencia utilizando métodos innovadores de fabricación. Se explorarán técnicas como impresión 3D, litografía avanzada, integración de materiales compuestos, y el uso de materiales emergentes como grafeno y metamateriales. Se discutirán aplicaciones en comunicaciones inalámbricas, sensores, dispositivos portátiles, redes 5G/6G y sistemas de radar, así como los retos asociados a miniaturización, eficiencia, fiabilidad y reproducibilidad en la fabricación. Esta sesión proporcionará una visión integral de cómo las nuevas técnicas de fabricación están transformando el desarrollo de dispositivos de RF, permitiendo estructuras más complejas, flexibles y eficientes, e impulsando la innovación tecnológica en comunicaciones, sensado y sistemas electromagnéticos avanzados." },
        { name: "Tecnologías Radio Avanzadas para la Evolución hacia 6G", summary: "La sesión especial propuesta busca presentar tecnologías de radio innovadoras, como antenas, filtros, estructuras reconfigurables y caracterización de canales de propagación, para avanzar desde 5G hacia los sistemas de comunicación 6G. Se enfoca en aprovechar las capacidades de la banda mmWave para sistemas de radio integrados y sus componentes, mientras explora aplicaciones de tipo \"prueba de concepto\" en comunicaciones sub-THz. Los objetivos incluyen optimizar las bandas mmWave y sub-THz mediante la incorporación del trazado de canales y coherencia espacial a la comprensión de la propagación dinámica, avanzar en tecnologías de radio para sistemas terrestres y aéreos/espaciales, y diseñar, fabricar y probar prototipos." },
        { name: "RFID y sensores RF", summary: "La sesión \"RFID y sensores RF\" explorará los avances recientes en identificación por radiofrecuencia (RFID) y sensores basados en radiofrecuencia, destacando su creciente importancia en aplicaciones de seguimiento, control y monitoreo. Se abordarán desarrollos en etiquetas inteligentes, sistemas de lectura de alta eficiencia, técnicas de detección pasiva y activa, y nuevos enfoques para mejorar la precisión y el alcance de los sensores. Se discutirán también aplicaciones innovadoras en logística, industria 4.0, salud, agricultura de precisión y ciudades inteligentes, así como los desafíos asociados a la miniaturización, la integración con IoT, la interoperabilidad y la seguridad de los datos. Esta sesión ofrecerá una visión integral de cómo la tecnología RFID y los sensores RF están transformando la adquisición de información y el monitoreo en tiempo real, combinando innovación tecnológica con aplicaciones prácticas que permiten optimizar procesos y generar soluciones inteligentes en múltiples sectores." },
        { name: "Ondas en plasmas", summary: "La sesión \"Ondas en plasmas\" explorará los avances recientes en el estudio de las propiedades, dinámica y aplicaciones de las ondas que se propagan en medios plasmáticos. Se analizarán fenómenos como ondas electromagnéticas y electrostáticas, modulaciones, inestabilidades, dispersión y no linealidades, así como su interacción con campos magnéticos y partículas cargadas. Se discutirán aplicaciones tanto en plasma de laboratorio como en plasma espacial y astrofísico, incluyendo confinamiento magnético, fusión nuclear, comunicaciones en la ionosfera y plasmas de alta energía. Además, se abordarán técnicas experimentales, numéricas y teóricas para caracterizar y controlar ondas en estos medios complejos. Esta sesión ofrecerá una visión integral del comportamiento de las ondas en plasmas y su relevancia para la física fundamental y aplicaciones tecnológicas avanzadas, destacando cómo la comprensión de estos fenómenos permite optimizar dispositivos, diagnosticar plasmas y explorar procesos en entornos naturales y controlados." },
        { name: "NextG (6G&B)", summary: "Las aplicaciones emergentes del Internet de las Cosas (IoT) buscan integrar personas, datos, procesos y objetos para satisfacer las necesidades de nuestra vida cotidiana. Se espera que las próximas redes inalámbricas de sexta generación y posteriores (6G&B), conocidas más como una extensión del 4G/5G, sean la columna vertebral del IoT y otros servicios, y respalden los sistemas IoT al ampliar su cobertura, reducir la latencia y mejorar la velocidad de datos. Los sistemas inalámbricos de próxima generación (NextG) requerirán un cambio de paradigma en su forma de interconectarse, organizarse, configurarse, optimizarse y recuperarse automáticamente, en función de sus condiciones operativas. Invitamos a los autores a enviar contribuciones originales sobre todas las áreas de las redes NextG (6G&B)." },
        { name: "Tecnologías emergentes para IoT", summary: "La sesión \"Tecnologías emergentes para IoT\" abordará los avances recientes en el desarrollo de soluciones innovadoras para el Internet de las Cosas (IoT). Se explorarán tecnologías habilitadoras como redes de baja potencia (LPWAN), conectividad 5G/6G, redes de corto alcance, sensores inteligentes, procesamiento en el borde (edge computing) y seguridad de datos, así como la integración de inteligencia artificial para optimizar la operación y la eficiencia de los sistemas IoT. Se discutirán aplicaciones prácticas en ciudades inteligentes, edificios inteligentes, salud, agricultura de precisión, industria 4.0 y monitoreo ambiental, destacando cómo estas tecnologías permiten una recolección de datos más eficiente, análisis en tiempo real y toma de decisiones automatizada." },
        { name: "Gestión de redes móviles de nueva generación basada en aprendizaje automático", summary: "El ámbito de la sesión abarca el uso de inteligencia artificial para la operación autónoma de redes asistidas por drones, redes no terrestres y escenarios con network slicing, así como la incorporación de gemelos digitales para el modelado, la simulación y la optimización continua del comportamiento de la red. Se presentarán avances en técnicas de aprendizaje automático aplicadas a la predicción del rendimiento, la asignación dinámica de recursos, y la detección proactiva de fallo, entre otros casos de uso. La sesión ofrecerá una visión integral de cómo la combinación de aprendizaje automático, gemelos digitales y tecnologías 5G/6G permitirá habilitar las \"redes de contacto cero\", capaces de adaptarse de forma inteligente a condiciones cambiantes." },
        { name: "Avances recientes en pequeños satélites para comunicaciones y observación de la Tierra", summary: "La sesión \"Avances recientes en pequeños satélites para comunicaciones y observación de la Tierra\" explorará los desarrollos más recientes en la tecnología de satélites pequeños, destacando su creciente papel en telecomunicaciones y observación terrestre. Se analizarán innovaciones en plataformas CubeSat y microsatélites, sistemas de comunicación de alta eficiencia, técnicas de propulsión compacta, redes satélite distribuidas y el uso de constelaciones para cobertura global. Además, se discutirán aplicaciones críticas en monitorización ambiental, gestión de desastres, agricultura de precisión y conectividad en áreas remotas, así como los retos técnicos asociados a miniaturización, confiabilidad y seguridad de los datos. Esta sesión ofrecerá una visión integral de cómo los satélites pequeños están revolucionando la comunicación y la observación terrestre, combinando innovación tecnológica con aplicaciones prácticas de alto impacto." },
        { name: "Proyectos de investigación en 6G", summary: "La sesión \"Proyectos de investigación en 6G\" presentará algunos de los proyectos de investigación que se están llevando a cabo en el contexto de los sistemas de comunicaciones móviles 6G, bien sean de ámbito nacional o europeo." },
        { name: "Nuevas Técnicas de Medida de Antenas", summary: "Las técnicas de medida de antenas y de radiación electromagnética abarcan diversos ámbitos de investigación, entre los que se incluyen nuevas técnicas de adquisición de campo basadas en mallados no regulares y en el uso de drones, robots y otros sistemas automatizados, con el objetivo de reducir los tiempos de medida o permitir la caracterización de estructuras de mayor tamaño y complejidad; nuevas técnicas de transformación de campo próximo a campo lejano; métodos avanzados de post-procesado orientados a mejorar la calidad y fiabilidad de las medidas; técnicas de medida over-the-air para sistemas MIMO y otras aplicaciones de comunicaciones inalámbricas; y técnicas específicas para la medida de la Sección Radar (RCS)." },
        { name: "Electromagnetismo en Biología y Medicina", summary: "La sesión \"Electromagnetismo en Biología y Medicina\" se centrará en los avances recientes en la aplicación de campos electromagnéticos en sistemas biológicos y médicos. Se explorarán temas como interacción de campos electromagnéticos con células y/o tejidos, técnicas de diagnóstico y terapia, bioelectromagnetismo, bioinstrumentación y sensores biomédicos. Se discutirán también desarrollos en resonancia magnética, terapias basadas en campos eléctricos o magnéticos, estimulación neuronal y tecnologías emergentes para monitoreo y tratamiento de enfermedades. Además, se abordarán aspectos relacionados con la seguridad, normativas y evaluación de exposición a campos electromagnéticos.Esta sesión proporcionará una visión completa de cómo el electromagnetismo está transformando la biomedicina, ofreciendo aplicaciones prácticas en diagnóstico, tratamiento y monitoreo de la salud, y mostrando cómo la investigación en este campo contribuye al desarrollo de tecnologías médicas más precisas, eficientes y seguras." },
        { name: "Teledetección", summary: "Esta sesión especial estará dedicada a explorar los avances recientes y las tendencias emergentes en el campo de la teledetección. Se abordarán desarrollos en sensores activos y pasivos, plataformas aéreas y espaciales, técnicas avanzadas de análisis basadas en inteligencia artificial y aprendizaje automático y aplicaciones relevantes en monitoreo ambiental, cambio climático, gestión de desastres, agricultura de precisión, vigilancia marítima y estudios urbanos." },
        { name: "Sistemas 6G e integración de comunicaciones y sensado", summary: "La sesión \"Sistemas 6G e integración de comunicaciones y sensado\" abordará los desarrollos recientes en redes móviles de sexta generación que combinan comunicaciones avanzadas con capacidades de sensado. Se explorarán tecnologías que permiten la transmisión de datos y la detección del entorno de manera simultánea, incluyendo el uso de ondas milimétricas y terahertz, antenas inteligentes, redes MIMO masivas y técnicas de inteligencia artificial para optimizar el rendimiento y la eficiencia espectral. Se discutirán aplicaciones innovadoras como vehículos autónomos, ciudades inteligentes, realidad extendida y monitoreo ambiental, así como los desafíos técnicos relacionados con latencias ultrabajas, confiabilidad, eficiencia energética y seguridad de los sistemas integrados. Esta sesión proporcionará una visión integral de cómo la convergencia entre comunicaciones y sensado en 6G está transformando la conectividad y la percepción del entorno, impulsando el desarrollo de redes más inteligentes, resilientes y capaces de soportar aplicaciones críticas de próxima generación." },
        { name: "Tecnologías Reflectarray y Transmitarray en Comunicaciones de Nueva Generación", summary: "Esta sesión especial busca mostrar los avances recientes en el ámbito de estructuras alimentadas espacialmente, con especial énfasis en los últimos desarrollos en tecnología reflectarray y transmitarray. La sesión busca incluir diferentes soluciones de antena basadas en estas tecnologías, para sistemas de comunicaciones en aplicaciones emergentes, tales como: antenas embarcadas en satélites pequeños o CubeSat, nuevas topologías reflectarray para futuros satélites de exploración espacial, o superficies inteligentes para su uso en futuros entornos de comunicación celular (5G/6G). Asimismo, otro de los objetivos de la sesión es abordar una visión actualizada sobre las nuevas técnicas de análisis y diseño de estas superficies, con especial atención a cómo se enfrentan a los retos impuestos por estos nuevos escenarios de comunicaciones emergentes." },
        { name: "Three Minute Thesis® (3MT)", summary: "" },
        { name: "Mujeres en RadioCiencia (WiRS)", summary: "" },
        { name: "Premio Jóvenes Científicos y Científicas", summary: "" },
        { name: "Premio INDRA", summary: "" },
    ];

    const handleClickOpen = (session) => {
        setSelectedSession(session);
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        setSelectedSession(null);
    };

    return (
        <Stack direction="column" margin={6} alignItems='center' spacing={6} sx={{
            width: 1, maxWidth: globalMaxWidth
        }}>

            <Stack spacing={2} margin={2} sx={{
                width: 1, maxWidth: globalMaxWidth
            }}
            >
                <Typography variant='h2' align='left'>
                    Áreas Temáticas
                </Typography>

                <Divider />

                <Typography align='justify'>
                    El Comité Organizador de URSI 2026 invita a la comunidad académica,
                    científica e industrial a la presentación de propuestas de Sesiones
                    Especiales dentro del marco del próximo simposio.
                </Typography>

                <Stack alignItems='center' direction={{ md: 'row', sm: 'column' }} spacing={2} alignContent='center' justifyContent='space-around'>
                    <Button variant='contained' margin={4} href={convocatoriaSesionesUrl}>
                        Descargar convocatoria
                    </Button>
                </Stack>
                <Divider />
                <Typography variant='h4' align='left'>
                    Sesiones Regulares
                </Typography>
                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item' }}>Acústica</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Antenas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Aplicaciones Biomédicas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Aplicaciones Matemáticas: Modelado y Simulación</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Circuitos y Dispositivos Activos de Microondas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Compatibilidad Electromagnética</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Componentes y Circuitos Pasivos de Microondas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Comunicaciones Digitales</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Comunicaciones Móviles e Inalámbricas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Comunicaciones por Satélite</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Educación: Nuevas Tecnologías y Herramientas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Electromagnetismo</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Fotónica y Comunicaciones Ópticas</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Metamateriales</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Procesado de Señal: Voz, Imagen y Datos</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Radar</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Radiación, Dispersión y Radiopropagación</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Radioastronomía</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Tecnología y Aplicaciones a Frecuencias de THz</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Telemática, IoT e Interfaces de Comunicación</ListItem>
                </List>

                <Divider />
                <Typography variant='h4' align='left'>
                    Sesiones Especiales
                </Typography>

                <Typography sx={{ color: 'primary.main' }}>
                    <strong>Pulsar sobre el título para mostrar el resumen de la sesión.</strong>
                </Typography>

                <List sx={{ listStyleType: 'disc' }}>
                    {specialSessions.map((session, index) => (
                        <ListItem
                            key={index}
                            sx={{
                                display: 'list-item',
                                cursor: 'pointer',
                                '&:hover': {
                                    backgroundColor: 'action.hover',
                                    color: 'primary.main'
                                }
                            }}
                            onClick={() => handleClickOpen(session)}
                        >
                            {session.name}
                        </ListItem>
                    ))}
                </List>

            </Stack>

            <Dialog
                open={openDialog}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {selectedSession?.name}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" align="justify" sx={{ mt: 2 }}>
                        {selectedSession?.summary}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>

    );
}

function Sede() {
    return (
        <Stack id='test' direction="column" margin={6} alignItems='center' spacing={6} sx={{
            width: 1, maxWidth: globalMaxWidth
        }}>
            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Sede
                </Typography>
                <Divider />
                <Typography variant='h5'>
                    Aulario General (Campus de Guajara)
                </Typography>
                <Typography variant='body1' align='justify'>
                    <strong> Dirección: </strong> Calle Prof. José Luis Moreno Becerra, s/n. 38200 San Cristóbal de La Laguna
                    (Tenerife) <Link href='https://www.ull.es/'> Universidad de La Laguna </Link>
                </Typography>
                <Button href="https://www.google.com/maps/search/?api=1&query=Aulario+General+Campus+de+Guajara+Universidad+de+La+Laguna"
                    sx={{ display: 'flex', justifyContent: 'center' }}>
                    <PlaceIcon sx={{ width: 50, height: 50 }} color='primary' />
                    <Typography color='secondary'> Google Maps </Typography>
                </Button>

                <Typography variant='body1' align='justify'>
                    El Aulario General de Guajara es el principal centro de docencia del Campus de Guajara de la Universidad de La Laguna.
                    En este campus se concentran la mayoría de las facultades de ciencias sociales, humanidades y económicas, como la Facultad de Derecho, la Facultad de Economía, Empresa y Turismo, y la Facultad de Educación.
                </Typography>
                <Typography variant='body1' align='justify'>
                    El edificio cuenta con modernas instalaciones, amplios vestíbulos y una gran variedad de aulas y anfiteatros equipados con las últimas tecnologías, ideales para la celebración de congresos científicos como URSI 2026.
                </Typography>
                <Grid container spacing={2} width={1}>
                    {[img0, img1, img2, img3, img4, img5].map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box sx={{
                                width: '100%',
                                height: '250px',
                                borderRadius: '8px',
                                boxShadow: 2,
                                overflow: 'hidden',
                                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                cursor: 'pointer',
                                '&:hover': {
                                    boxShadow: 8,
                                    '& img': {
                                        transform: 'scale(1.05)',
                                    }
                                }
                            }}>
                                <Box component="img"
                                    src={img}
                                    alt={`Sede ${index}`}
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        display: 'block',
                                        transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                        willChange: 'transform',
                                        backfaceVisibility: 'hidden',
                                        imageRendering: 'auto', // standard for photos
                                    }}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                <Divider />
                <Typography variant='h4' id='comollegar'>
                    Cómo llegar
                </Typography>
                <Typography variant='h5'>
                    En coche
                </Typography>

                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography variant='body1' sx={{ mb: 2 }}>
                            <strong>
                                Acceso en coche desde la TF-5 (sentido Santa Cruz, viniendo desde el Aeropuerto Tenerife
                                Norte – Los Rodeos)
                            </strong>
                        </Typography>
                        <List>
                            <ListItem sx={{ display: 'list-item' }}>
                                <Typography variant='body2'>
                                    Toma la <strong>salida 9</strong> hacia <strong>TF-13</strong>, en
                                    dirección <strong>Guajara / Campus de Guajara</strong>.
                                </Typography>
                            </ListItem>

                            <ListItem sx={{ display: 'list-item' }}>
                                <Typography variant='body2'>
                                    Sigue las indicaciones hacia el <strong>Campus de Guajara</strong>. Encontrarás múltiples zonas de aparcamiento alrededor del Aulario.
                                </Typography>
                            </ListItem>
                        </List>

                    </ListItem>
                </List>
                <ListItem sx={{ display: 'list-item' }}>
                    <Typography variant='body1'>
                        <strong>
                            Acceso en coche desde la TF-5 (sentido Santa Cruz – La Laguna)
                        </strong>
                    </Typography>

                    <List>
                        <ListItem sx={{ display: 'list-item' }}>
                            <Typography variant='body2'>
                                Toma la <strong>salida 9</strong> en dirección <strong>Guajara</strong>.
                            </Typography>
                        </ListItem>

                        <ListItem sx={{ display: 'list-item' }}>
                            <Typography variant='body2'>
                                En la rotonda, toma las indicaciones hacia el <strong>Campus de Guajara</strong>.
                            </Typography>
                        </ListItem>
                    </List>
                </ListItem>

                <Typography variant='h5'>
                    Parking
                </Typography>

                <Typography variant='body1' sx={{ mb: 2 }}>
                    El Campus de Guajara dispone de amplias zonas de aparcamiento público y gratuito para estudiantes y visitantes, situadas principalmente junto a la Facultad de Economía y el Aulario General.
                </Typography>

                <Typography variant='h5'>
                    En Guagua (Autobús)
                </Typography>

                <Typography variant='body1' sx={{ mb: 2 }}>
                    Varias líneas de TITSA conectan el Campus de Guajara con el resto de la isla. Las líneas principales que paran directamente en el campus o en sus inmediaciones son la 015, 102, 103 y 108. Consulta horarios en <Link href='https://www.titsa.com/'>TITSA</Link>.
                </Typography>

                <Typography variant='h5'>
                    En tranvía (Tranvía de Tenerife)
                </Typography>

                <Typography variant='body1' sx={{ mb: 2 }}>
                    La línea 1 del tranvía tiene una parada específica denominada <strong>"Campus Guajara"</strong>, que deja a escasos metros del Aulario General. Es la opción más cómoda si te desplazas desde Santa Cruz o el centro de La Laguna. Puede consultar horarios en: <Link href='https://metrotenerife.com/'>Metrotenerife</Link>.
                </Typography>

                <Typography variant='h5'>
                    Taxi
                </Typography>
                <Typography variant='body1'>
                    Hay paradas de taxi disponibles en todo el campus. Un taxi desde el Aeropuerto Tenerife Norte (TFN) tarda aproximadamente 10 minutos.
                </Typography>
                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        <Typography variant='body1'>
                            La Laguna - Santa Cruz: 12-18 €.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        <Typography variant='body1'>
                            Aeropuerto Tenerife Norte - La Laguna: 15-20 €.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        <Typography variant='body1'>
                            Aeropuerto Tenerife Sur - La Laguna: 65-75€.
                        </Typography>
                    </ListItem>
                </List>
                <Typography variant='h5'>
                    Aeropuertos (llegadas)
                </Typography>
                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography variant='body1'>
                            <strong>Aeropuerto Tenerife Norte (TFN — Tenerife Norte / Ciudad de La Laguna)</strong>: el
                            aeropuerto está muy próximo a La Laguna (pocos kilómetros), guagua o taxi te dejan en el
                            Intercambiador en pocos minutos.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <Typography variant='body1'>
                            <strong>Aeropuerto Tenerife Sur (TFS — Reina Sofía)</strong>: se encuentra a ~60–65 km; hay
                            autobuses interurbanos con transbordo o taxi (trayecto ~40–75 min según tráfico).
                        </Typography>
                    </ListItem>
                </List>
            </Stack>
        </Stack>
    );
}

function Comunicaciones() {
    return (
        <Stack direction="column" margin={6} alignItems='center' width={1} spacing={6} sx={{
            width: 1, maxWidth: globalMaxWidth
        }}>
            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Comunicaciones
                </Typography>
                <Divider />
                <Typography variant='body1'>
                    <strong>Las comunicaciones deberán seguir las siguientes instrucciones generales:</strong>
                </Typography>
                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item' }}>Los trabajos deberán seguir las plantillas que el congreso pone a su disposición.</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Los trabajos deberán tener una extensión máxima de 4 páginas.
                        No existirá extensión mínima pero se recomienda que los artículos que se presenten al Premio
                        URSI a los jóvenes científicos tengan la extensión máxima.</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Los trabajos pueden ser escritos y presentados en español o
                        inglés.</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Para optar al premio URSI-España Jóvenes Científicos/as,
                        premio INDRA y concurso Tesis en 3 minutos (3MT), tener en cuenta las condiciones descritas en
                        el apartado Premios y Concursos.</ListItem>
                </List>
                <Typography variant='h2' align='left'>
                    Envío de documentos
                </Typography>
                <Divider />

                <Stack alignItems='center'>
                    <Button variant='contained' width='auto' href="https://www.conftool.pro/ursi2026/">
                        Registro y subida de contribuciones
                    </Button>
                </Stack>

                <Typography variant='body' align='center'>
                    Disponible a partir del 2 de febrero del 2026
                </Typography>

                <Typography variant='h2' align='left'>
                    Descargar Documentos
                </Typography>
                <Divider />
                <Grid container spacing={2} justifyContent='space-around'>
                    <Grid item size={2}>
                        {/*// TODO Añadir documento (estará el lunes).*/}
                        <Button href={call_for_papers}>
                            <Stack direction='column' alignItems='center' spacing={1}>
                                <PictureAsPdf fontSize='large' />
                                <Typography variant='h7'>
                                    Call for papers (esp)
                                </Typography>
                            </Stack>
                        </Button>
                    </Grid>
                    <Grid item size={2}>
                        <Button href={template_word_es}>
                            <Stack direction='column' alignItems='center' spacing={1}>
                                <InsertDriveFile fontSize='large' />
                                <Typography variant='h7'>
                                    Plantilla URSI 2026 (esp)
                                </Typography>
                            </Stack>
                        </Button>
                    </Grid>

                    <Grid item>
                        <Button href={template_latex_es}>
                            <Stack direction='column' alignItems='center' spacing={1}>
                                <Description fontSize='large' />
                                <Typography variant='h7'>
                                    Plantilla URSI 2026 Latex (esp)
                                </Typography>
                            </Stack>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button href={template_word_en}>
                            <Stack direction='column' alignItems='center' spacing={1}>
                                <InsertDriveFile fontSize='large' />
                                <Typography variant='h7'>
                                    Template URSI 2026 (eng)
                                </Typography>
                            </Stack>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button href={template_latex_en}>
                            <Stack direction='column' alignItems='center' spacing={1}>
                                <Description fontSize='large' />
                                <Typography variant='h7'>
                                    Template URSI 2026 Latex (eng)
                                </Typography>
                            </Stack>
                        </Button>
                    </Grid>
                </Grid>

            </Stack>
        </Stack>
    );
}

function Comités() {
    return (
        <Stack direction="column" alignItems='center'>
            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Comité organizador
                </Typography>
                <Divider />
            </Stack>

            <Stack direction='column' alignItems='left' spacing={1} width={1}>
                <Typography variant='h5'>
                    Presidentes
                </Typography>

                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Manuel Rodriguez Valido (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Jonas Philip Lüke (Universidad de La Laguna)
                    </ListItem>
                </List>
                <Typography variant='h5'>
                    Vocales
                </Typography>
                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Óscar Gómez Cárdenes (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Felix Ángel Herrera Priano (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Tony Castillo Calzadilla (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Juan Manuel Martín Doñas (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Kumar Mahtani (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        José Ignacio Estévez Damas (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Isabel Sánchez Berriel (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Mikel Laso (Presidente del comité español de la URSI)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Pablo Padilla (Secretario del comité español de la URSI)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        David Girbau Sala (Presidente URSI 2025, Universitat Rovira i Virgili)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Antonio Ramón Lázaro Guillén (Presidente URSI 2025, Universitat Rovira i Virgili)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Fernando Las Heras Andrés (Presidente URSI 2027, Universidad de Oviedo)
                    </ListItem>
                </List>
            </Stack>

            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Comité científico
                </Typography>
                <Divider />
            </Stack>

            <Stack direction='column' alignItems='left' spacing={1} width={1}>
                <Typography variant='h5'>
                    Presidentes
                </Typography>

                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Manuel Rodriguez Valido (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Jonas Philip Lüke (Universidad de La Laguna)
                    </ListItem>
                </List>
                <Typography variant='h5'>
                    Vocales
                </Typography>
                <List sx={{ listStyleType: 'disc' }}>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Óscar Gómez Cárdenes (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Felix Ángel Herrera Priano (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Tony Castillo Calzadilla (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Juan Manuel Martín Doñas (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        Kumar Mahtani (Universidad de La Laguna)
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', ml: 3 }}>
                        José Ignacio Estévez Damas (Universidad de La Laguna)
                    </ListItem>
                </List>
            </Stack>

        </Stack>
    );

}

function Inscripciones() {

    function Tabla() {
        return (
            <TableContainer component={Card}>
                <Table>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: 'secondary.main',
                        }}>
                            <TableCell>
                                <Typography color='white'>
                                    Tipo de Cuota
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color='white'>
                                    Hasta el 05/06/2026
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color='white'>
                                    Hasta el 19/07/2026
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow sx={{ backgroundColor: 'secondary.table_row' }}>
                            <TableCell>
                                Estudiante
                            </TableCell>
                            <TableCell>
                                400.00 €
                            </TableCell>
                            <TableCell>
                                505.00 €
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                Senior
                            </TableCell>
                            <TableCell>
                                550.00 €
                            </TableCell>
                            <TableCell>
                                655.00 €
                            </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: 'secondary.table_row' }}>
                            <TableCell>
                                Senior con <strong>artículo adicional</strong>
                            </TableCell>
                            <TableCell>
                                850.00 €
                            </TableCell>
                            <TableCell>
                                955.00 €
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                URSI Senior and Fellow Members (**)
                            </TableCell>
                            <TableCell>
                                500.00 €
                            </TableCell>
                            <TableCell>
                                655.00 €
                            </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: 'secondary.table_row' }}>
                            <TableCell>
                                URSI Senior and Fellow Members con <strong>artículo adicional</strong> (**)
                            </TableCell>
                            <TableCell>
                                800.00 €
                            </TableCell>
                            <TableCell>
                                955.00 €
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                Acompañante (***)
                            </TableCell>
                            <TableCell>
                                250.00 €
                            </TableCell>
                            <TableCell>
                                300.00 €
                            </TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
            </TableContainer>
        );
    }


    return (
        <Stack direction="column" margin={4} alignItems='center' width={1} spacing={6} sx={{
            width: 1, maxWidth: globalMaxWidth
        }}>
            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Inscripciones y Tarifas
                </Typography>
                <Divider />
                <Tabla />
            </Stack>

            <Stack spacing={2} margin={2}>
                <Typography variant='body1'>
                    En caso de que un artículo sea aceptado, es obligatorio completar la inscripción y efectuar el pago
                    antes del 5 de junio de 2026 para beneficiarse de la tarifa reducida, o hasta el 19 de julio de 2026
                    con la tarifa estándar. De no cumplirse este requisito, la comunicación no será incluida en las
                    actas del Congreso.
                </Typography>

                <Typography variant='body1'>
                    (*) Aquellos congresistas que realicen su inscripción con la cuota de “ESTUDIANTE” deberán adjuntar
                    una copia de la matrícula correspondiente al curso 2025/2026 que demuestre la condición de
                    estudiante (Grado, Máster o Doctorado). Podrán adjuntarla una vez finalizado el proceso de
                    inscripción, al final de la página, en el apartado “Enviar mensaje a Secretaría Técnica”. Podrán
                    acceder a este apartado desde su perfil. La cuota de estudiantes cubre únicamente un artículo y no
                    permite la opción de inscribir un artículo adicional.
                </Typography>

                <Typography variant='body1'>
                    (**) Aquellos congresistas que realicen su inscripción con la cuota de “URSI Senior and Fellow Members” deben entrar el número de miembro de URSI-Internacional en el momento de cursar la inscripción. La categoría de URSI Senior/Fellow Member es asignada directamente por URSI-Internacional (no por URSI-España) y no es lo mismo que ser socio/a o socio/a de honor de URSI-España.
                </Typography>

                <Typography variant='body1'>
                    (***) Incluye las actividades sociales: entrada al cóctel de bienvenida, visitas culturales del
                    miércoles y del jueves y cena de gala.
                </Typography>
            </Stack>

            <Stack direction='row' alignItems='center' spacing={2}>
                <Info fontSize='large' color='primary' />
                <Typography variant='body1'>
                    Las inscripciones al congreso se abrirán a partir del 22 de abril de 2026, hasta el 05 de junio de
                    2026
                    con tarifa reducida y hasta el 19 de julio de 2026 con tarifa normal.
                </Typography>
            </Stack>
            <Stack alignItems='center'>
                <Button enabled variant='contained' margin={4} href="https://tenerife.congresoseci.com/ursi2026">
                    Inscripción
                </Button>
            </Stack>

            <Typography variant='body2'>
                <strong>Política de cancelación:</strong> Las solicitudes de cancelación deberán enviarse por correo
                electrónico a congresoursi2026@ull.edu.es. Para las solicitudes de cancelación recibidas hasta el 19 de
                julio de 2026 incluido, se reembolsará la cuota de inscripción, menos el 10% en concepto de gastos de
                gestión.
                Para las solicitudes de cancelación recibidas después de esa fecha no se reembolsará la cuota de
                inscripción.
            </Typography>
        </Stack>
    );

}

function Premios() {
    return (
        <Stack direction="column" margin={6} alignItems='center' width={1} spacing={6} sx={{
            width: 1, maxWidth: globalMaxWidth
        }}>
            <Stack spacing={2} margin={2}>
                <Typography variant='h2' align='left'>
                    Premios y Concursos
                </Typography>
                <Divider />
                <Link href='https://ursi.es/simposio-nacional/#premioURSI'>
                    <Typography variant='h5' color='primary'>
                        Premio URSI-España Jóvenes Científicos/as
                    </Typography>
                </Link>
                <Typography variant='body1' align='justify'>
                    Para apuntarse al premio URSI-España Jóvenes Científicos/as, además de cumplir con las bases de la
                    convocatoria, en el momento de enviar la contribución es necesario que señale la candidatura
                    marcando la pestaña correspondiente para optar a este premio. Además, como cualquier otra
                    contribución, es necesario que señale los temas / sesiones afines a la contribución ya que ayudarán
                    a los organizadores a asignar revisores correctamente.

                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*Comité de Selección: Por definir.*/}
                    <br />
                    <br />

                    <Link href='https://ursi.es/simposio-nacional/#premioURSI'>
                        <Typography variant='body' color='primary'>
                            Enlace a la convocatoria.
                        </Typography>
                    </Link>

                    {/*<strong>1.º Premio: 500€</strong>*/}
                    {/*<br/>*/}
                    {/*<strong>2.º Premio: 300€</strong>*/}
                    {/*<br/>*/}
                    {/*<strong>3.º Premio: 200€</strong>*/}
                    {/*<br/>*/}
                </Typography>

                <Divider />
                <Link href='https://ursi.es/simposio-nacional/#INDRA'>
                    <Typography variant='h5' color='primary'>
                        Premio INDRA
                    </Typography>
                </Link>
                <Typography variant='body1' align='justify'>
                    INDRA, como entidad patrocinadora del Simposio URSI’2026
                    otorgará el IV Premio INDRA al mejor artículo sobre tecnologías
                    relacionadas con Baja Observabilidad. Se premiarán los dos
                    mejores artículos sobre tecnologías FSS (Frequency Selective
                    Surface), metamateriales, metodología para obtención de firma
                    radar (RCS) por simulación, diseño de antenas de baja RCS, y
                    otras tecnologías que puedan tener aplicación, de forma directa
                    o indirecta, en sensores para plataformas <i>Stealth</i>.
                </Typography>
                <Typography variant='body1' align='justify'>
                    Para apuntarse al premio INDRA, además de cumplir con las bases de la convocatoria, en el momento de
                    enviar la contribución es necesario que señale la candidatura marcando la pestaña correspondiente
                    para optar a este premio. Además, como cualquier otra contribución, es necesario que señale los
                    temas / sesiones afines a la contribución ya que ayudarán a los organizadores a asignar revisores
                    correctamente.
                </Typography>
                <Typography variant='body1' align='justify'>
                    Toda la información relativa al <strong>Premio INDRA</strong> se puede consultar
                    en la web del Simposio o a través del siguiente enlace:
                    <Link href="https://ursi.es/simposio-nacional/#INDRA">https://ursi.es/simposio-nacional/#INDRA</Link>.

                    {/*Comité de Selección: por definir.*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<strong>1.º Premio: 500€ </strong>- Patrocinado por <Link href='https://www.indracompany.com/'>INDRA</Link>*/}
                    {/*<br/>*/}
                    {/*<strong>2.º Premio: 400€</strong>- Patrocinado por <Link href='https://www.indracompany.com/'>INDRA</Link>*/}
                </Typography>

                <Divider />
                <Link href='https://ursi.es/simposio-nacional/#3MT'>
                    <Typography variant='h5' color='primary'>
                        Concurso Tesis en 3 Minutos (3MT)
                    </Typography>
                </Link>
                <Typography variant='body1' align='justify'>
                    Para apuntarse al concurso 3MT, además de cumplir con las bases de la convocatoria, en el momento de enviar la contribución (que en este caso consistirá simplemente en una transparencia estática en PDF, que será también la que se usará de soporte en la presentación durante el Simposio) se debe seleccionar la opción "Presentación Three Minute Thesis (3MT)" y será necesario aportar un link (en un campo previsto para ello en el aplicativo) a un vídeo subido a Youtube de duración (máximo) 3 minutos.
                </Typography>
                <Typography variant='body1' align='justify'>
                    El formato del vídeo es libre; sin embargo, es imprescindible que la presentación de soporte sea claramente visible y la narración se escuche con claridad.
                </Typography>
                <Typography variant='body1' align='justify'>
                    El plazo para enviar las candidaturas al Premio 3MT estará abierto más allá de la notificación, el 8 de mayo, de la aceptación de los trabajos para dar más margen a la preparación del video.  La fecha límite de entrega será el 15 de junio..
                    {/*Comité de Selección: por definir.*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<strong>1.º Premio: 300€ </strong>*/}
                </Typography>

                <Link href='https://ursi.es/simposio-nacional/#Fomento-Femenino'>
                    <Typography variant='h5' color='primary'>
                        Premio de Vocaciones de Mujeres en Radiociencia de URSI-España: Embajadora WiRS
                    </Typography>
                </Link>
                <Typography variant='body1' align='justify'>
                    Para optar al Premio de Vocaciones de Mujeres en Radiociencia de URSI-España: Embajadora WiRS, es necesario cumplir
                    las bases de la convocatoria y completar el formulario correspondiente, según se indica en el <Link
                        href='https://ursi.es/mujeres-en-radio-ciencia/'>Capítulo Español de Mujeres en Radiociencia de
                        URSI-España.</Link>
                </Typography>
                <Typography variant='body1' align='justify'>
                    Se anunciará el plazo para el envío de candidaturas en esa misma web y por los medios habituales de URSI-España (email, RRSS) a comienzos de 2026. Este premio está gestionado directamente por el Capítulo WIRS de URSI-España. Para más información y aclaraciones: <Link href='wirsursies@gmail.com'>wirsursies@gmail.com</Link>.
                </Typography>
                {/*Comité de Selección:*/}
                {/*<br/>*/}
                {/*<br/>*/}
                {/*<strong>1.º Premio: 500€</strong>*/}
                {/*<br/>*/}
                {/*<strong>2.º Premio: 250€</strong>*/}
                {/*<br/>*/}
                {/*<strong>3.º Premio: 250€</strong>*/}
                {/*<br/>*/}
            </Stack>
        </Stack>
    );
}

export default Simposio;
